import { useEffect, useState } from 'react';
import apiClient from '../../../services/apiService';

/**
 * Fetch a MIS-report endpoint (object OR array payload). Re-runs when the
 * endpoint or params change. On failure: logs, exposes error, yields null.
 */
export function useReport(endpoint, params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const key = JSON.stringify(params || {});

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const res = await apiClient.get(endpoint, params ? { params } : undefined);
        if (!cancelled) {
          setData(res.data?.data ?? null);
          setError(null);
        }
      } catch (e) {
        console.error(`Error fetching ${endpoint}:`, e);
        if (!cancelled) {
          setError('Failed to load report data');
          setData(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, key, attempt]);

  // A page load fires one request per widget, so a burst can trip the API rate
  // limit and fail a few of them — give callers a way to retry just their own.
  const refetch = () => setAttempt((n) => n + 1);

  return { data, loading, error, refetch };
}
